var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"switch-bar"},_vm._l((_vm.data),function(tab,index){return _c('div',{key:index,staticClass:"tab",class:{ active: _vm.tabIndex === index },on:{"click":function($event){return _vm.changeTab(index, tab)}}},[_c('span',[_vm._v(_vm._s(tab.name ? tab.name : tab))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }